const Policy = () => {
    return (
        <div>
            <h1>Policy</h1>
        </div>
    );
};

export default Policy;
